import { createSelector } from 'reselect';

const storeCourses = (store, props) => store.courseData.courses;
const storeCourseLevels = (store, props) => store.courseData.courseLevels;
const storeLinkedData = (store, props) => store.courseData.linkedData;
const storeRelationship = (store, props) => store.courseData.relationship;
const storeCurrentCourseLevel = (store, props) =>
  store.courseData.currentCourseLevel;
const storeDataLoading = (store, props) => store.courseData.dataLoading;
const storeCourseKey = (store, props) => store.courseData.currentCourseKey;

export const propsCourseKey = (store, props) => {
  if (props.match && props.match.params) {
    const { courseKey = '' } = props.match.params;
    return courseKey;
  }

  return '';
};

export const getCourseId = createSelector(
  storeCourses,
  storeCourseKey,
  (courses, key) => (courses && key && courses[key] ? courses[key].id : '')
);

export const getCourses = createSelector(
  storeCourses,
  courses => {
    const keys = Object.keys(courses);

    if (keys.length > 0) {
      return keys.map(courseKey => courses[courseKey]);
    }
    return [];
  }
);

export const getCurrentCourse = createSelector(
  storeCourses,
  propsCourseKey,
  (courses, key) => (courses && key && courses[key]) || null
);

export const getCurrentCourseLevelId = createSelector(
  storeCurrentCourseLevel,
  level => level
);

export const getAllCourseLevels = createSelector(
  storeCourseLevels,
  levels => (levels && Object.keys(levels).map(key => levels[key])) || []
);

export const getCourseLevelData = createSelector(
  storeCourseLevels,
  storeCurrentCourseLevel,
  (levels, levelId) => (levels && levelId && levels[levelId]) || []
);

export const getCourseToolsImages = createSelector(
  storeCourseLevels,
  storeCurrentCourseLevel,
  (levels, levelId) => (levels && levelId && levels[levelId].toolUrls) || []
);

export const getCourseTitleAndDescription = createSelector(
  storeCourses,
  propsCourseKey,
  (courses, courseKey) => {
    const course = courses[courseKey] ? courses[courseKey] : null;
    return course
      ? { title: course.title || '', description: course.description || '' }
      : { title: '', description: '' };
  }
);

// export const getCourseAllLiveProjects = createSelector(
//     storeRelationship,
//     storeLinkedData,
//     (relation, data) => {
//              if(relation && relation['liveProjects'] && data){

//               const result =  [];
//               relation['liveProjects'].forEach((id) => {
//                 if(data[id])
//                 {
//                  result.push({
//                     id: data[id].id,
//                     ...data[id].attributes
//                   })
//                 }
//               });
//               return result;
//              }
//              return [];
//     }

// );

export const getCourseLevelLiveProjects = createSelector(
  storeRelationship,
  storeLinkedData,
  storeCurrentCourseLevel,
  (relation, data, courseLevel) => {
    if (relation && relation['liveProjects'] && data) {
      const result = [];
      relation['liveProjects'][courseLevel].forEach(id => {
        if (data['liveProjects'][id]) {
          result.push({
            id: data['liveProjects'][id].id,
            ...data['liveProjects'][id].attributes
          });
        }
      });
      return result;
    }
    return [];
  }
);

export const getAllLevelLinkedData = createSelector(
  storeRelationship,
  storeLinkedData,
  (relations, data) => {
    const result = {};

    if (!relations || !data) {
      return result;
    }

    Object.keys(relations).forEach(relationKey => {
      const relation = relations[relationKey];

      if (!relation) {
        return;
      }

      Object.keys(relation).forEach(courseId => {
        const ids = relation[courseId] || [];

        result[courseId] = {
          ...result[courseId],
          [relationKey]:
            result[courseId] && result[courseId][relationKey]
              ? [
                  ...result[courseId][relationKey],
                  ...ids.map(id => {
                    if (data[relationKey][id]) {
                      return {
                        id,
                        ...data[relationKey][id].attributes
                      };
                    }
                  })
                ]
              : [
                  ...ids.map(id => {
                    if (data[relationKey][id]) {
                      return {
                        id,
                        ...data[relationKey][id].attributes
                      };
                    }
                  })
                ]
        };
      });
    });

    return result;
  }
);

// export const getCourseAllFeedbacks = createSelector(
//     storeRelationship,
//     storeLinkedData,
//     (relation, data) => {
//              if(relation && relation['feedbacks'] && data){

//               const result =  [];
//               relation['feedbacks'].forEach((id) => {
//                 if(data[id])
//                 {
//                  result.push({
//                     id: data[id].id,
//                     ...data[id].attributes
//                   })
//                 }
//               });
//               return result;
//              }
//              return [];
//     }

// );

export const getCourseLevelFeedbacks = createSelector(
  storeRelationship,
  storeLinkedData,
  storeCurrentCourseLevel,
  (relation, data, courseLevel) => {
    if (relation && data && courseLevel && relation['feedbacks']) {
      const result = [];
      relation['feedbacks'][courseLevel].forEach(id => {
        if (data['feedbacks'][id]) {
          result.push({
            id: data['feedbacks'][id].id,
            ...data['feedbacks'][id].attributes
          });
        }
      });
      return result;
    }
    return [];
  }
);

// export const getCourseAllCompanies = createSelector(
//     storeRelationship,
//     storeLinkedData,
//     (relation, data) => {

//              if(relation && relation['internshipCompanies'] && data){

//               const result =  [];
//               relation['internshipCompanies'].forEach((id) => {
//                 if(data[id])
//                 {
//                  result.push({
//                     id: data[id].id,
//                     ...data[id].attributes
//                   })
//                 }
//               });
//               return result;
//              }
//              return [];
//     }

// );

export const getCourseLevelCompanies = createSelector(
  storeRelationship,
  storeLinkedData,
  storeCurrentCourseLevel,
  (relation, data, courseLevel) => {
    if (relation && relation['internshipCompanies'] && data) {
      const result = [];
      relation['internshipCompanies'][courseLevel].forEach(id => {
        if (data['internshipCompanies'][id]) {
          result.push({
            id: data['internshipCompanies'][id].id,
            ...data['internshipCompanies'][id].attributes
          });
        }
      });

      return result;
    }
    return [];
  }
);

export const isDataLoading = createSelector(
  storeDataLoading,
  loading => loading
);



// WEBPACK FOOTER //
// ./src/selectors/course.js